var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/lock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 10.75C17.59 10.75 17.25 10.41 17.25 10V8C17.25 4.85 16.36 2.75 12 2.75C7.64 2.75 6.75 4.85 6.75 8V10C6.75 10.41 6.41 10.75 6 10.75C5.59 10.75 5.25 10.41 5.25 10V8C5.25 5.1 5.95 1.25 12 1.25C18.05 1.25 18.75 5.1 18.75 8V10C18.75 10.41 18.41 10.75 18 10.75Z",
    fill: "#4DA8B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 22.75H7C2.59 22.75 1.25 21.41 1.25 17V15C1.25 10.59 2.59 9.25 7 9.25H17C21.41 9.25 22.75 10.59 22.75 15V17C22.75 21.41 21.41 22.75 17 22.75ZM7 10.75C3.42 10.75 2.75 11.43 2.75 15V17C2.75 20.57 3.42 21.25 7 21.25H17C20.58 21.25 21.25 20.57 21.25 17V15C21.25 11.43 20.58 10.75 17 10.75H7Z",
    fill: "#4DA8B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 17C7.87 17 7.74 16.97 7.62 16.92C7.49 16.87 7.39001 16.8 7.29001 16.71C7.11001 16.52 7 16.27 7 16C7 15.87 7.02999 15.74 7.07999 15.62C7.12999 15.49 7.20001 15.39 7.29001 15.29C7.39001 15.2 7.49 15.13 7.62 15.08C7.98 14.92 8.42999 15.01 8.70999 15.29C8.79999 15.39 8.87001 15.5 8.92001 15.62C8.97001 15.74 9 15.87 9 16C9 16.26 8.88999 16.52 8.70999 16.71C8.51999 16.89 8.26 17 8 17Z",
    fill: "#4DA8B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 17C11.74 17 11.48 16.89 11.29 16.71C11.11 16.52 11 16.27 11 16C11 15.87 11.02 15.74 11.08 15.62C11.13 15.5 11.2 15.39 11.29 15.29C11.52 15.06 11.87 14.95 12.19 15.02C12.26 15.03 12.32 15.05 12.38 15.08C12.44 15.1 12.5 15.13 12.56 15.17C12.61 15.2 12.66 15.25 12.71 15.29C12.8 15.39 12.87 15.5 12.92 15.62C12.97 15.74 13 15.87 13 16C13 16.27 12.89 16.52 12.71 16.71C12.66 16.75 12.61 16.79 12.56 16.83C12.5 16.87 12.44 16.9 12.38 16.92C12.32 16.95 12.26 16.97 12.19 16.98C12.13 16.99 12.06 17 12 17Z",
    fill: "#4DA8B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16 17C15.73 17 15.48 16.89 15.29 16.71C15.2 16.61 15.13 16.5 15.08 16.38C15.03 16.26 15 16.13 15 16C15 15.74 15.11 15.48 15.29 15.29C15.34 15.25 15.39 15.21 15.44 15.17C15.5 15.13 15.56 15.1 15.62 15.08C15.68 15.05 15.74 15.03 15.8 15.02C16.13 14.95 16.47 15.06 16.71 15.29C16.89 15.48 17 15.73 17 16C17 16.13 16.97 16.26 16.92 16.38C16.87 16.51 16.8 16.61 16.71 16.71C16.52 16.89 16.26 17 16 17Z",
    fill: "#4DA8B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ffe4cbb68a7e4b6cc0b26f80153b50db.svg";
export { ForwardRef as ReactComponent };